import script from "./KjsChat.vue?vue&type=script&setup=true&lang=js"
export * from "./KjsChat.vue?vue&type=script&setup=true&lang=js"

import "./KjsChat.vue?vue&type=style&index=0&id=6c5a0b44&lang=css"

const __exports__ = script;

export default __exports__